import { BaseContainerModel } from '../base-container.model';

import { bl_mrp_process_type_hdr_RowClass } from '../../dbschema/bl_mrp_process_type_hdr.model';
import { bl_mrp_process_type_ext_RowClass } from '../../dbschema/bl_mrp_process_type_ext.model';
import { bl_mrp_process_type_line_RowClass } from '../../dbschema/bl_mrp_process_type_line.model';

export class MrpProcessTypeContainerModel extends BaseContainerModel {
  bl_mrp_process_type_hdr: bl_mrp_process_type_hdr_RowClass = new bl_mrp_process_type_hdr_RowClass();
  bl_mrp_process_type_exts: bl_mrp_process_type_ext_RowClass[] = [];
  bl_mrp_process_type_lines: bl_mrp_process_type_line_RowClass[] = [];
}
